import { useRef, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { authActions, alertActions } from '@actions';
import { authService } from '@services';
import { useTranslation } from '@hooks';

export default function useNavigationBookmarks() {
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch();
    const store = useStore();
    const { t } = useTranslation();
    const savingRef = useRef(false);
    const [saving, setSaving] = useState(false);
    const bookmarks = user?.navigationBookmarks || [];

    const toggleBookmark = async path => {
        if (!user || savingRef.current) return;

        savingRef.current = true;
        setSaving(true);
        const next = bookmarks.includes(path) ? bookmarks.filter(value => value !== path) : [...bookmarks, path];
        try {
            const navigationBookmarks = await authService.updateNavigationBookmarks(next);
            if (store.getState().auth.user?.id === user.id) {
                dispatch(authActions.patchUser({ navigationBookmarks }));
            }
        } catch {
            if (store.getState().auth.user?.id === user.id) {
                dispatch(alertActions.error(t('alertMessages.updateFail')));
            }
        } finally {
            savingRef.current = false;
            setSaving(false);
        }
    };

    return { bookmarks, toggleBookmark, saving };
}
